import script from "./lyVideo.vue?vue&type=script&setup=true&lang=js"
export * from "./lyVideo.vue?vue&type=script&setup=true&lang=js"

import "./lyVideo.vue?vue&type=style&index=0&id=303a0a46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-303a0a46"]])

export default __exports__